export const DIAN_MODALITY = {
  COMPUTER: 2,
  INVOICE: 3,
  POS: 4,
  CONTINGENCY: 5,
  SUPPORT_DOCUMENT: 6,
  EQUIVALENT_DOCUMENT: 7,
};

const normalizeModalityId = (modalityId) => Number(modalityId);

export const isInvoiceModality = (modalityId) =>
  normalizeModalityId(modalityId) === DIAN_MODALITY.INVOICE;

export const isContingencyModality = (modalityId) =>
  normalizeModalityId(modalityId) === DIAN_MODALITY.CONTINGENCY;

export const isComputerModality = (modalityId) =>
  normalizeModalityId(modalityId) === DIAN_MODALITY.COMPUTER;

export const isPosModality = (modalityId) =>
  normalizeModalityId(modalityId) === DIAN_MODALITY.POS;

export const isSupportModality = (modalityId) =>
  normalizeModalityId(modalityId) === DIAN_MODALITY.SUPPORT_DOCUMENT;

export const isEquivalentModality = (modalityId) =>
  normalizeModalityId(modalityId) === DIAN_MODALITY.EQUIVALENT_DOCUMENT;

export const isElectronicInvoiceModality = (modalityId) =>
  isInvoiceModality(modalityId) || isContingencyModality(modalityId);
